const offers = (Swiper) => {
    const offersMain = document.querySelector(".offers, .offers-module");
    if (offersMain) {
        const offersLightbox = offersMain.querySelector(".offers__lightbox");
        const offersItems = offersMain.querySelector(".offers__items, .offers-module .row");
        const offersSlider = offersLightbox.querySelector(".swiper-container");
        const closeLightbox = offersMain.querySelector(".offers__lightbox-close");
        let offersSwiper = false;
        if (offersSlider) {
            offersSwiper = new Swiper(offersSlider, {
                navigation: {
                    prevEl: offersLightbox.querySelector(".offers__lightbox-prev"),
                    nextEl: offersLightbox.querySelector(".offers__lightbox-next"),
                }
            })
        }
        if (offersItems) {
            offersItems.addEventListener("click", function(e){
                if (e.target.dataset.hasOwnProperty("id") && offersSwiper) {
                    console.log(e.target);
                    const slides = offersSwiper.slides;
                    for (var i = 0; i < slides.length; i++) {
                        if (slides[i].dataset.hasOwnProperty("id")) {
                            if (e.target.dataset.id === slides[i].dataset.id) {
                                offersSwiper.slideTo(i);
                                offersLightbox.classList.add("open");
                            }
                        }
                    }
                }
            });
        }
        if (closeLightbox) {
            closeLightbox.addEventListener("click", function() {
                offersLightbox.classList.remove("open");
            });
        }
    }
}

export default offers;
